exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.truncate[data-v-434b9dbd]:hover {\n  white-space: normal;\n  text-align: justify;\n  text-justify: inter-word;\n}\n", ""]);

// exports
